/* eslint-disable @typescript-eslint/no-unused-vars */
import { ISource } from '@stores/source';
import { TAB_NAMES } from '@components/sources/source-view';
import { DIRECTORY_TABS } from '@components/common/constants';
import {
  AccountValidator,
  ConfigurationComponentProps,
  CredentialsAuth,
  DirectoryTab,
  ResourcesComponentProps,
  SourceCategory,
} from './sourceCategory';

const Unimplemented = 'Method not implemented';

class EventStreamSource extends SourceCategory {
  override isNewConnectionAllowed() {
    return true;
  }

  override validateAccount(_: AccountValidator): Promise<string | undefined> {
    throw new Error('Method not implemented.');
  }

  override getAccountsEndpoint(_?: string): string {
    throw Error('Method not supported');
  }

  override getSourceType(sourceDef: { name: string }) {
    switch (sourceDef.name.toLowerCase()) {
      case 'javascript':
        return 'web';
      case 'android':
      case 'ios':
      case 'unity':
      case 'reactnative':
      case 'flutter':
      case 'cordova':
      case 'amp':
        return sourceDef.name.toLowerCase();
      default:
        return 'cloud';
    }
  }

  override handleSetup(_: boolean, __: boolean, create: () => void) {
    create();
    return true;
  }

  override isPartOf(tab: DirectoryTab) {
    return tab === DIRECTORY_TABS.EVENT_STREAMS;
  }

  override getAuthComponent(_: CredentialsAuth): JSX.Element {
    throw new Error(Unimplemented);
  }

  override getTabs(_: ISource) {
    return [
      TAB_NAMES.DESTINATIONS,
      ...(process.env.REACT_APP_DISABLE_REPORTING ? [] : [TAB_NAMES.EVENTS]),
      TAB_NAMES.SETTINGS,
    ];
  }

  override getResourcesComponent(_: ResourcesComponentProps): JSX.Element {
    throw new Error(Unimplemented);
  }

  override getConfigurationComponent(_: ConfigurationComponentProps): JSX.Element {
    throw new Error(Unimplemented);
  }
}

export default EventStreamSource;
